module.exports = __webpack_public_path__ + "img/2-2.0b5032b3.svg";